import React, {Fragment} from 'react';
import {RecipeModel} from "../../logic/models/RecipeModel";
import InformationList from "../../reusable/Information/InformationList";
import {Svgs} from "../../assets/svgs/Svgs";
import UnitInput from "../../reusable/ControlledForm/Inputs/UnitInput";
import Divider from "../../reusable/Styles/Divider";
import BoxesWrapper from "../../reusable/Layouts/BoxesWrapper";
import {lengthUnits} from "../../global/lists";
import {useTranslation} from "react-i18next";
import {TranslationParser} from "../../translations/TranslationParser";

type ConverterZoneProps = {
    recipe: RecipeModel
}

function ConverterZone(props: ConverterZoneProps) {
    const {recipe} = props
    const {t} = useTranslation("common")
    const lengthOptions = lengthUnits.map(unit => { return {value: unit, name: unit}})
    const informations = recipe.retrieveListData().filter(information => information.label === "height" || information.label === "diameter")
    const convertZone = () => {
        return [
            <InformationList informations={TranslationParser.parseUnits(t, informations)} withDivider={true}/>,
            <Svgs.ArrowSvg/>,
            <Fragment>
                <UnitInput numberName={"diameterOut"} label={t('units.length.diameter')+ ":"} unitName={"diameterUnitOut"} options={lengthOptions}/>
                <Divider/>
                <UnitInput numberName={"heightOut"} label={t("units.length.height")+ ":"} unitName={"heightUnitOut"} options={lengthOptions}/>
            </Fragment>
        ]
    }
    return (
        <BoxesWrapper className="convert-boxes" boxes={convertZone()}/>
    );
}

export default ConverterZone;
